const TYPES = {
    AnimationRepository: Symbol("AnimationRepository"),
    EnemyRepository: Symbol("EnemyRepository"),
    PartyRepository: Symbol("PartyRepository"),
    DialogRepository: Symbol("DialogRepository"),
    KeyboardMappingRepository: Symbol("KeyboardMappingRepository"),
    SceneContextService: Symbol("SceneContextService"),
    GameStateService: Symbol("GameStateService"),
    EventService: Symbol("EventService"),
    PlayerService: Symbol("PlayerService"),
    NPCService: Symbol("NPCService"),
    EnemyService: Symbol("EnemyService"),
    BattleService: Symbol("BattleService"),
    BattleContextService: Symbol("BattleContextService"),
    KeyboardMappingService: Symbol("KeyboardMappingService"),
    GeometryService: Symbol("GeometryService"),
    SocketIOService: Symbol("SocketIOService"),
    UIMapService: Symbol("UIMapService"),
    AnimationService: Symbol("AnimationService"),
    CameraService: Symbol("CameraService"),
    AuthService: Symbol("AuthService"),
    ThemeManager: Symbol("ThemeManager"),
    AuthenticatedAssetLoader: Symbol("AuthenticatedAssetLoader"),
    SaveGameService: Symbol("SaveGameService"),
    MessageQueueService: Symbol("MessageQueueService"),
};

export default TYPES;
